<template>
    <div id="app">
        <div class="page-mobile">
            <headerNav></headerNav>
            <router-view></router-view>
            <pc-footer />
            <animation />
        </div>
    </div>
</template>

<script>
import headerNav from '../components/mobile/header'
import pcFooter from '../components/mobile/footer'
import animation from '../components/mobile/animation'
export default {
    name: 'MobileLayout',
    components: {
        headerNav,
        pcFooter,
        animation
    }
}
</script>

<style lang="less">
@import "../less/m/main";
.page-mobile {
    width: 100%;
    min-height: 100%;
}
</style>
